// Return the API URL taking into account whether the app is being run
// in production/development
export const getApiUrl = () => (
  process.env.NODE_ENV === 'production'
  ? 'http://r01.ds.cs.umu.se/getimage_mongo_v2.php?image='
  : 'http://r01.ds.cs.umu.se/getimage_mongo_v2.php?image='
)
